<script>
  // import SvelteMarkdown from 'svelte-markdown';
  import '$lib/styles/markdown.css';

  export let data;
  const post = data.post.data;

  //COPYRIGHT START - © 2024 Daan Schenkel & Oscar Knap - Alle rechten voorbehouden
  // let renderedContent = '';

  // $: {
  //   let newRenderedContent = post.content;
  //   if (!newRenderedContent) newRenderedContent = '';

  //   newRenderedContent.replaceAll('\r\n', '\n');
  //   newRenderedContent = newRenderedContent.replace(
  //     /(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/g,
  //     '`$&`'
  //   );

  //   renderedContent = newRenderedContent;
  // }

  // const options = {
  //   gfm: true,
  //   breaks: true
  // };
  //COPYRIGHT END - © 2024 Daan Schenkel & Oscar Knap - Alle rechten voorbehouden
</script>

<svelte:head>
  <title>{post.title} · League-FM</title>
</svelte:head>

<div class="bg-neutral flex flex-col items-center pb-8">
  {#if post.file}
    <img src={post.file} alt="Blog post cover" class="mt-8 max-h-96 rounded-xl" />
  {/if}

  <div class="flex flex-row items-center">
    <div class="font-introrust badge badge-success mr-4 mt-2 text-sm text-white">
      {post.category.displayName}
    </div>
    <h1 class="mb-4 mt-6 text-3xl font-bold">{post.title}</h1>
  </div>

  <div class="mb-6 flex flex-row">
    {#if post.user != null && post.user.displayName != ''}
      {post.user.displayName}
      <p class="mx-2 font-bold">·</p>
      Geplaatst op {new Date(post.createdAt).toLocaleDateString()}
    {:else}
      Geplaatst op {new Date(post.createdAt).toLocaleDateString()}
    {/if}
  </div>

  <span
    class="editor-preview-active w-9/10 mx-16 rounded-xl border bg-base-100 p-8"
    style="white-space: pre-wrap"
    >{post?.content?.replaceAll('<', '')?.replaceAll('>', '')?.replaceAll('"', '') || ''}</span
  >
</div>

<style>
  .editor-preview-active {
    max-width: 100%;
  }
</style>
